import { ApiEndpoints } from "@shared/api/api-endpoints";
import { mxApiClient } from "@shared/api/clients/apiClientFactory";
import { PAGE_SIZE } from "@shared/utils/constants";

export const getMeterRuns = async (
  page: any,
  utilityId: string,
  collection_methods?: string,
  limit: number = PAGE_SIZE,
  search?: string
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "meter-run",
    (query) => {
      query.push("remote_utility_id", utilityId);
      query.push("page", page);
      query.push("limit", limit);
      if (collection_methods) {
        query.push("collection_methods", collection_methods);
      }
      if (search) {
        query.push("search_data", search);
      }
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data ?? [];
};

export const getMeterRunCounts = async (
  utilityId: string,
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "meter-run/counts",
    (query) => {
      query.push("remote_utility_id", utilityId);
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data?.result || {};
};

export const getMeterRunDetail = async (
  id: string | number,
  utilityId: string | number,
  meterType?: string
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    `meter-run/detail/${id}`,
    (query) => {
      query.push("remote_utility_id", utilityId);
      if (meterType) {
        query.push("meter_type", meterType);
      }
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data?.result || response.data || {};
};

export const getRoutes = async (
  page: any,
  utilityId: string | number,
  limit: number = PAGE_SIZE,
  cycleId?: string | number,
  search?: string
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "route",
    (query) => {
      query.push("is_pagination_required", "true");
      query.push("remote_utility_id", utilityId);
      query.push("page", page);
      query.push("limit", limit);
      if (cycleId) {
        query.push("cycle_id", cycleId);
      }
      if (search) {
        query.push("search_data", search);
      }
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data ?? {};
};

export const getMeterReadings = async (
  page: any,
  utilityId: string | number,
  meterRunId: string | number,
  limit: number = PAGE_SIZE,
  search?: string,
  utilityService?: string,
  type?: string,
  subType?: string,
  condition?: string,
  status?: string,
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "meter-reading",
    (query) => {
      query.push("remote_utility_id", utilityId);
      query.push("meter_run", meterRunId);
      query.push("page", page);
      query.push("limit", limit);
      if (search) query.push("search_data", search);
      if (utilityService) query.push("utility_service", utilityService);
      if (type) query.push("type", type);
      if (subType) query.push("sub_type", subType);
      if (condition) query.push("condition", condition);
      if (status) query.push("status", status);
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data ?? {};
};

export const getReaderEfficiencySummary = async (
  utilityId: string | number,
  meterRunId: string | number,
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "reader-efficiency-summary",
    (query) => {
      query.push("remote_utility_id", utilityId);
      query.push("meter_run_id", meterRunId);
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data;
};

export const getReaderEfficiencyList = async (
  page: any,
  utilityId: string | number,
  meterRunId: string | number,
  limit: number = PAGE_SIZE,
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "reader-efficiency-list",
    (query) => {
      query.push("remote_utility_id", utilityId);
      query.push("meter_run_id", meterRunId);
      query.push("page", page);
      query.push("limit", limit);
      return query;
    },
  );
  const response = await mxApiClient.get(url);
  return response.data;
};

export const getMeterDispatchDetail = async (params: {
  meter_run_id: string;
  remote_utility_id: string;
  page: number;
  origin: string;
  meter_reader_id?: any;
  run_status?: any;
  search?: string;
}): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "mx",
    "meter-dispatch/detail",
    (query) => {
      query.push("run_id", params.meter_run_id);
      query.push("remote_utility_id", params.remote_utility_id);
      query.push("page", params.page);
      query.push("limit", PAGE_SIZE);
      query.push("origin", "Web");

      if (params.meter_reader_id) {
        query.push("meter_reader_id", params.meter_reader_id);
      }
      if (
        params.run_status !== null &&
        params.run_status !== undefined &&
        params.run_status !== ""
      ) {
        query.push("status", params.run_status);
      }
      if (params.search) {
        query.push("search_data", params.search);
      }
      return query;
    }
  );
  const response = await mxApiClient.get(url);
  return response.data;
};
